(function(){
    'use strict';

    angular
    .module('appback')
    .controller('PreanaliticaController', PreanaliticaController)
 
    PreanaliticaController.$inject = ["socket","ResultadosService","GenerallabService","PreanaliticaService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function PreanaliticaController(socket,ResultadosService,GenerallabService,PreanaliticaService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this; 
        vm.loading = false;
        vm.grid = "";
        vm.printService = new WebSocketPrinter();

        vm.printRaw = function(value) {
            vm.printService.submit({
                'type': 'INVOICE',
                'raw_content': value
            });
        };
        /*
        ^XA
        ^FX Third section with barcode.
        ^FO44,30
        ^BY1
        ^BC,100,Y,N,N,A
        ^FD200929001^FS
        ^FO 181,30
        ^BY1
        ^BC,100,Y,N,N,A
        ^FD200929002^FS
        ^FO 318,30
        ^BY1
        ^BC,100,Y,N,N,A
        ^FD200929003^FS
        ^FO 455,30
        ^BY1
        ^BC,100,Y,N,N,A
        ^FD200929004^FS
        ^XZ*/
        vm.init = function(){
        	//$.pjax.reload({container:'#w0'});
	       
        };


        vm.filtrar = function(){
        	$('[name="ViewEncaminoSearch[lims_id]"]').val(vm.lims_id);
        	//$.fn.yiiGridView.update('#w0');
        	//$('#w0').yiiGridView('applyFilter');
        	$.pjax.reload('#pjax-grid-view', {timeout: 1000});

        };
        vm.cambiarPendiente = function(lims_id){
        	PreanaliticaService.cambiarPendiente(lims_id,function(data){
                if(data.carta.length>0){
                    //console.log("EMIT nueva carta");
                    for(var cont=0;cont<data.carta.length;cont++){
                        socket.emit('pizarra:nuevacarta', { carta:data.carta[cont] });
                    }
                }
				$.pjax.reload('#pjax-grid-view', {timeout: 1000});
			});
        };

        function format(icon) {
            var originalOption = icon.element;
              var str = "";
              if(typeof $(originalOption).data('icon') != 'undefined'){
                str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
                return $(str+" ");
              }else{
                return icon.text || icon.value;
              }
        }

        vm.optionsTiposMuestra = { 
    		ajax: {
                url: "/backend/altcrm/content/select2",
                dataType: 'json',
                delay: 250,
                data: function (params) {
                  return {
                    q: params.term, // search term
                    page: params.page,
                    field: 'nombre',
                    per_page: 20,
                    nodetype:'tipomuestra'
                  };
                },
                processResults: function (data, params) {
                  params.page = params.page || 1;
                  return {
                    results: data.items,
                    pagination: {
                      more: (params.page * 1) < data.total_count
                    }
                  };
                },
                cache: true
            },
            templateSelection: format,
            templateResult: format
    	};

        vm.optionsEstadomuestra = { 
            ajax: {
                url: "/backend/altcrm/content/select2",
                dataType: 'json',
                delay: 250,
                data: function (params) {
                  return {
                    q: params.term, // search term
                    page: params.page,
                    field: 'nombre',
                    per_page: 20,
                    nodetype:'estadomuestra'
                  };
                },
                processResults: function (data, params) {
                  params.page = params.page || 1;
                  return {
                    results: data.items,
                    pagination: {
                      more: (params.page * 1) < data.total_count
                    }
                  };
                },
                cache: true
            },
            templateSelection: format,
            templateResult: format
        };

        vm.optionsTipotubo = { 
            ajax: {
                url: "/backend/altcrm/content/select2",
                dataType: 'json',
                delay: 250,
                data: function (params) {
                  return {
                    q: params.term, // search term
                    page: params.page,
                    field: 'nombre',
                    per_page: 20,
                    nodetype:'tipotubo'
                  };
                },
                processResults: function (data, params) {
                  params.page = params.page || 1;
                  return {
                    results: data.items,
                    pagination: {
                      more: (params.page * 1) < data.total_count
                    }
                  };
                },
                cache: true
            },
            templateSelection: format,
            templateResult: format
        };

	    vm.modalPeticion = "";
        vm.modalOK = "";
        vm.modalInfoLlegada = "";
        vm.modalEnvioAlic = "";

        vm.enviarAlic = function(peticion_id){
            PreanaliticaService.getAlic(peticion_id,function(data){
                vm.modalEnvioAlic = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'enviosalic.html',
                  size: 'lg',
                  backdrop:'static',
                  controller: function($scope) {
                    $scope.generalLab = GenerallabService;
                    $scope.data = data;
                    $scope.muestrasEstados = data.muestrasEstados;
                    $scope.peticion_id = peticion_id;
                    $scope.disabled = false;

                    $scope.existeTipo = function(tipo){
                        var res = false;
                        for(var cont=0;cont<$scope.muestrasEstados.length && !res;cont++){
                            if($scope.muestrasEstados[cont].tipomuestra_id == tipo.id && $scope.muestrasEstados[cont].active==1){
                                res = true;
                            }
                        }
                        return res;
                    }

                    $scope.okForm = function(){
                        $scope.disabled = true;
                        PreanaliticaService.saveAlic($scope,function(){
                            location.reload();
                        })
                    }

                    $scope.koForm = function(){
                        vm.modalEnvioAlic.close();
                    };
                  }
                });
            });
        }

        vm.getLLegada = function() {
            PreanaliticaService.getLlegada(vm.lims_id,function(data){
                if(data.peticion){
                    vm.modalInfoLlegada = $uibModal.open({
                      animation: true,
                      ariaLabelledBy: 'modal-title-top',
                      ariaDescribedBy: 'modal-body-top',
                      templateUrl: 'peticionInfo.html',
                      size: 'lg',
                      backdrop:'static',
                      controller: function($scope) {
                        $scope.peticion = data.peticion;
                        $scope.analiticas = data.analiticasPeticion;
                        $scope.generalLab = GenerallabService;
                        $scope.muestrasEstados = data.muestrasEstados;
                        $scope.muestrasEnviadas = data.muestrasEnviadas;
                        $scope.printRaw = function(){
                            //vm.printRaw(data.print);
                        }

                        $scope.okForm = function(){
                            $scope.disabled = true;
                            PreanaliticaService.marcarLLegada($scope.laboratorio_id,$scope.peticion[0].id,$scope,function(dataLlegada){
                               if(dataLlegada.code==10){
                                   vm.modalInfoLlegada.close();
                                   vm.lims_id = "";
                                   $scope.muestrasEstados = dataLlegada.muestrasEstados;
                               }else{
                                   alert("ERROR FATAL (VUELVE A PROBAR).");
                               }
                                $scope.disabled = false;

                            });
                        }

                        $scope.koForm = function(){
                            vm.modalInfoLlegada.close();
                                   vm.lims_id = "";
                        };
                      }
                    });
                }
            });
        }

        vm.getMuestras = function(id){
            vm.loading = true;
            vm.modalAcciones = "";
        	PreanaliticaService.getPeticion((id ? id : vm.lims_id),function(data){
	            vm.loading = false;
	            if(data.peticion){
	            	//MOSTRAMOS POPUP
		            vm.modalPeticion = $uibModal.open({
		                  animation: true,
		                  ariaLabelledBy: 'modal-title-top',
		                  ariaDescribedBy: 'modal-body-top',
		                  templateUrl: 'peticion.html',
		                  size: 'full',
		                  backdrop:'static',
		                  controller: function($scope) {
                              $timeout(function(){
                                  $('.trackinginp').focus();
                              },1000);
                            $scope.currentPeticion = data.peticionCurrent;
                            $scope.generalLab = GenerallabService;

                            $scope.optionsEstadomuestra = vm.optionsEstadomuestra;
                            $scope.optionsTipotubo = vm.optionsTipotubo;
		                  	$scope.optionsTiposMuestra = vm.optionsTiposMuestra;
		                    $scope.peticion = data.peticion;
                            $scope.tracking = "";
		                    $scope.loadingEstado = false;
                            $scope.peticionCambiado = {};

                            $scope.getAcciones = function(id){
                                ResultadosService.getAccionesByPet(id,function(data){
                                    $scope.generalLab.acciones = data.acciones;
                                    vm.modalAcciones = $uibModal.open({
                                      animation: true,
                                      ariaLabelledBy: 'modal-title-top',
                                      ariaDescribedBy: 'modal-body-top',
                                      templateUrl: 'accionespre.html',
                                      size: 'lg',
                                      //backdrop:'static',
                                      controller: function($scope) {
                                        $scope.generalLab = GenerallabService;
                                          $scope.koForm = function(){
                                                vm.modalAcciones.close();
                                            };
                                      }
                                      });
                                    
                                });
                                //console.log("E");
                            }

                            $scope.borrarTipo = function(peticion,index){
                                peticion.tiposestados.splice(index,1);
                            };
                            $scope.generarNuevo = function(){
                                //console.log("nuevo");
                                $scope.tracking=Date.now();
                            };
                            $scope.cambiarId = function(peticion){
                                $scope.currentPeticion = peticion;
                            };

                            $scope.cambiarANO = function(index,pre,petin){
                                petin.preanalitica_lab.analiticasPueden.splice(index,1);
                                petin.preanalitica_lab.analiticasNoPueden.push(pre);
            
                            } 

                            $scope.cambiarASI = function(index,pre,petin){
                                petin.preanalitica_lab.analiticasNoPueden.splice(index,1);
                                petin.preanalitica_lab.analiticasPueden.push(pre);
            
                            } 

                            $scope.printCode = function(value){
                                /*var myImage = "data:image/png;base64,"+peticion.barcode;
                                var myWindow = window.open("", "Image");
                                myWindow.document.write("<div style='overflow:hidden'><div style='float:left;margin-right:10px'><img style='max-height:40px;margin-top:5px;text-align:center;font-weight:bold;' src='"+myImage+"''><br/>"+peticion.id+"</div><div style='float:left;margin-right:10px'><img style='max-height:40px;margin-top:5px;text-align:center;font-weight:bold;' src='"+myImage+"''><br/>"+peticion.id+"</div><div style='float:left;margin-right:10px'><img style='max-height:40px;margin-top:5px;text-align:center;font-weight:bold;' src='"+myImage+"''><br/>"+peticion.id+"</div><div style='float:left;'><img style='max-height:40px;margin-top:5px;text-align:center;font-weight:bold;' src='"+myImage+"''><br/>"+peticion.id+"</div></div>");
                                myWindow.print();
                                myWindow.close();
                                //console.log("print");*/
                                //window.print();
                                vm.printRaw(value);
                            };
		                    $scope.okForm = function(){
		                    	vm.lims_id = "";
		                        vm.modalPeticion.close();

                                //$.pjax({container: '#pjax-grid-view',async:false})
                                $.pjax.reload('#pjax-grid-view', {timeout : false});
		                    };
		                    $scope.koForm = function(){
		                    	vm.lims_id = "";
		                        vm.modalPeticion.close();
		                    };
		                    $scope.cambiarPediente = function(peticion){
		                   		$scope.loadingEstado = true;
                                peticion.tracking = $scope.tracking;
        						PreanaliticaService.cambiarPendiente(peticion,function(data){
                                    if(typeof(data.carta)!= 'undefined' && data.carta.length>0){
                                        //console.log("EMIT nueva carta");
                                        for(var cont=0;cont<data.carta.length;cont++){
                                            socket.emit('pizarra:nuevacarta', { carta:data.carta[cont] });
                                        }
                                    }
                                    if(data.code!=-1000){
    									//$.pjax.reload('#pjax-grid-view', {timeout: 1000});
    		                        	//vm.modalPeticion.close();

                                        var res = false;
                                        ////console.log($scope.peticion);
                                        ////console.log($scope.currentPeticion);
                                        for(var cont=0;cont<$scope.peticion.length && !res;cont++){
                                            if($scope.peticion[cont].id==peticion.id){
                                                res = cont;
                                            }
                                        }
                                        if(res>=0){
                                            $scope.peticion.splice(res,1);
                                            if($scope.peticion.length>0){
                                                $scope.currentPeticion = $scope.peticion[0];
                                            }else{
                                                vm.modalPeticion.close();
                                                $.pjax.reload('#pjax-grid-view', {timeout : false});
                                            }
                                        }
                                        
    		                   			$scope.loadingEstado = false;
    		                    		vm.lims_id = "";
                                        
                                        vm.modalOK = $uibModal.open({
                                          animation: true,
                                          ariaLabelledBy: 'modal-title-top',
                                          ariaDescribedBy: 'modal-body-top',
                                          templateUrl: 'modalok.html',
                                          size: 'lg',
                                          backdrop:'static',
                                          controller: function($scope) {
                                            $scope.peticionCambiado = data.res;
                                            $scope.peticion = peticion;
                                            $scope.printRaw = function(){
                                                vm.printRaw(data.print);
                                            }
                                             $scope.koForm = function(){
                                                vm.modalOK.close();
                                            };
                                          }
                                        });
                                        vm.printRaw(data.print);
                                    }else{
                                       alert("CODIGO REPETIDO, VUELVE A DARLE AL BOTÓN");
                                       $scope.loadingEstado = false;

                                    }
        						});
		                    };
		                  }
		              });

	            }
        		//vm.grid = data.grid;
	        });
        	//$.pjax({container: '#pjax-grid-view'})
			//$("#pjax-grid-view").submit();
			//$.pjax.reload({container: '#pjax-grid-view'});
        	//$.pjax.reload({container:'#pjax-grid-view'});
        };
        //console.log("prean");

        vm.init();
       
    }
  
})();